export type Locale = 'fa' | 'en';
export const LOCALES: readonly Locale[] = ['fa', 'en'];
export const DEFAULT_LOCALE: Locale = 'fa';
export const dirFor = (locale: Locale): 'rtl' | 'ltr' => (locale === 'fa' ? 'rtl' : 'ltr');
export const isLocale = (v: unknown): v is Locale => v === 'fa' || v === 'en';
export const bcp47 = (locale: Locale) => (locale === 'fa' ? 'fa-IR' : 'en-US');
